import { skipToken, useQuery } from '@tanstack/react-query';

import { Assets } from '@air/api';
import { type Asset, type WorkspaceInfo } from '@air/api/types';

import { getVersionsListKey } from '~/constants/react-query-keys';
import { filterOutNullVersions } from '~/utils/VersionUtils';

export type PrivateVersionsListParams = {
  assetId: Asset['id'] | undefined;
  workspaceId: WorkspaceInfo['id'] | undefined;
};

export type UsePrivateVersionsListOptions = {
  enabled?: boolean;
};

export const usePrivateVersionsList = (params: PrivateVersionsListParams, options?: UsePrivateVersionsListOptions) => {
  const { assetId, workspaceId } = params;

  return useQuery({
    queryKey: getVersionsListKey({ assetId }),
    queryFn:
      assetId && workspaceId
        ? async () => {
            const versions = await Assets.listVersions({
              assetId,
              workspaceId,
              limit: 500,
            });

            /** There is a bug in backend that returns versions with status "created" and "version: null"
             * @see https://air-labs-team.slack.com/archives/CCS4C8ALT/p1701368808930219
             */
            return filterOutNullVersions(versions);
          }
        : skipToken,
    enabled: !!assetId && !!workspaceId && (options?.enabled ?? true),
  });
};
